import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import View from "./View";

export default function Container({textSet, clickExit, dismiss}) {
  const dispatch = useDispatch();
  const [popupText, setPopupText] = useState([
    "Are you sure",
    "you want to leave?",
  ]);

  useEffect(() => {
    if (textSet && textSet.length > 0) {
      setPopupText(textSet);
    }
  }, [textSet]);

  const onClickExit = () => {
    clickExit();
    dismiss();
  };
  const onClickClose = () => {
    dismiss();
  };

  return (
    <View
      textSet={popupText}
      onClickExit={onClickExit}
      onClickClose={onClickClose}
    />
  );
}
